// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SIButoonDiv{text-align:center}.scheduleItemsButton{border:unset;text-align:center;background-color:#bbb;padding:0 35px;border-radius:20px;display:inline-block;vertical-align:middle;font-size:11px;color:#fff;line-height:20px;font-weight:400;margin-top:10px;margin-bottom:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
